import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
 // import {Md5} from 'ts-md5/dist/md5';
import { ElementRef, ViewChild, Inject } from '@angular/core';
import { DoctorService } from '../../services/doctor.service';
import * as firebase from 'firebase';
@Component({
  selector: 'app-pleasewait',
  templateUrl: './pleasewait.component.html',
  styleUrls: ['./pleasewait.component.css']
})
export class PleasewaitComponent implements OnInit {
    title1: any;
    did: any;
    timer: any;
    counter = 60;
    uid: any;
    messaging = firebase.messaging();
    body: any;
    mess :any;
    mess2 : any;
  constructor(public dialogRef: MatDialogRef<PleasewaitComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any, private doctorService: DoctorService) { 

        this.uid = data.id;
        this.did = data.did;
    this.timer = setInterval(() => this.intoTime(), 1000);

    this.postChatRequests();

    this.messaging.onMessage(message => {
        this.body = message;
        this.mess = this.body.data.data;
    
        this.mess2 = JSON.parse(this.mess);
    
       
        if(this.mess2['@type'] == 'new-message-payload'){
          if(this.mess2.message.payloadType == 'vn.petcart.notification'){
            var notifpayload=this.mess2.message.messageData.filter(datum => datum.dataType == 'petcart-notification-payload')[0]
            this.CheckTitle(notifpayload.data.title);
          }
        }
     });
  }

  ngOnInit() {

  }



  postChatRequests(){
    var status= "Requested";
    this.doctorService.postChatRequests(this.uid, this.did, status)
    .subscribe((x)=>{
      this.data = x;

    },(err)=>{
      if (err.status === 501) {
        clearInterval(this.timer);
        this.dialogRef.close("Doctor is busy");
      }
    });
  }

  getChatRequests(z) {
    clearInterval(this.timer);
    this.dialogRef.close(z);
  }

  intoTime(){
    this.counter = this.counter - 1;
    if(this.counter === 0) {
      clearInterval(this.timer);
       this.dialogRef.close("Not Answered");
    } 
  }

  

  CheckTitle(x) {
    this.title1 = x.substring(0, 19);
       const title = x.substr(0, x.indexOf(' ')); // "72"
       const reqid =  x.substr(x.indexOf(' ') + 1);

       if(this.title1 === "ChatRequestAccepted") {
        var status1 = title.substring(11, 19);
        this.getChatRequests(status1);
    } else if(this.title1 === "ChatRequestRejected") {
        var status2 = title.substring(11, 19);
        this.getChatRequests(status2);
    }
   }

}